// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__24gJY","Open":"SideDrawer_Open__2H-Cd","Close":"SideDrawer_Close__2OVem"};